'use client';

import { type ReactNode } from 'react';
import { useNativeInit } from '@/lib/native';
import PullToRefresh from '@/components/PullToRefresh';

/**
 * Provider that initializes Capacitor native plugins exactly once.
 * Wrap your app with this inside the Providers component.
 *
 * Only this component should call useNativeInit — it registers the global
 * StatusBar / SplashScreen / Keyboard / Android back-button listeners.
 * Components that only need to know the platform call the read-only
 * useNativeApp() instead.
 */
export function NativeProvider({ children }: { children: ReactNode }) {
  useNativeInit();
  return (
    <>
      <PullToRefresh />
      {children}
    </>
  );
}
